mutation DELETE_PARKING_SCHEDULE($id: UUID!) {
  deleteParkingSchedule(id: $id) {
    success
    error
  }
}
